import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { setCpdCianSource, setCpdSource, setPrelandingModalOpen } from 'shared/actions/cpd';
import { CPDHomeownerTrap } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { ECpdPrelandingModalView } from 'shared/types/cpd/cpd';

export const CPDHomeownerTrapContainer: React.FC = () => {
  const { trackCPDTrapVisible, trackCPDTrapClick } = useCpdTracking();
  const dispatch = useDispatch();

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  const onTrapClick = React.useCallback(() => {
    dispatch(setPrelandingModalOpen({ isOpen: true, modalView: ECpdPrelandingModalView.Homeowner }));
    dispatch(setCpdSource('homeownerOffer'));
    dispatch(setCpdCianSource('homeownerOffer_web'));
    trackCPDTrapClick('trapOffer');
  }, []);

  if (!prelandingContent?.homeowner) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={() => trackCPDTrapVisible('trapOffer')} callbackDelay={1000}>
      <CPDHomeownerTrap onClick={onTrapClick} />
    </ActionAfterViewObserver>
  );
};
